import { render, staticRenderFns } from "./DIDDEX.vue?vue&type=template&id=8d38ba8e&scoped=true&"
import script from "./DIDDEX.vue?vue&type=script&lang=js&"
export * from "./DIDDEX.vue?vue&type=script&lang=js&"
import style0 from "./DIDDEX.vue?vue&type=style&index=0&id=8d38ba8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d38ba8e",
  null
  
)

export default component.exports